import { LeadType } from '@/lib/entities/lead';

import { Button } from '@/lib/shared/components/Buttons';
import { Messengers } from '@/lib/shared/components/Messengers';
import { modal, FeedBackModalNew } from '@/lib/shared/components/Modal';
import { H2, P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './IncomeCalculation.module.scss';

type IncomeCalculationProps = {
  title?: string;
  expert?: string;
  buttonLabel?: string;
  className?: string;
  modalTitle?: string;
  sourceForm?: string;
  comment?: string;
  withSocials?: boolean;
  description?: string;
  leadType?: LeadType;
};

export const IncomeCalculation = ({
  title = 'incomeCalculationTitle',
  expert = '/images/team/calculation_expert.webp',
  buttonLabel = 'incomeCalculationButton',
  modalTitle = 'getCalculation',
  sourceForm = 'request_calculation',
  comment = 'Запрос расчета доходности',
  description = 'rentIncomCalculationTitle',
  withSocials = false,
  leadType = 'SALE',
  className,
}: IncomeCalculationProps) => {
  const { t } = useTranslation('index', { keyPrefix: 'landingInvest' });
  const openModal = () => {
    modal.open(
      <FeedBackModalNew
        title={modalTitle}
        subTitle={'getCallBack'}
        leadType={leadType}
        sourceForm={sourceForm}
        comment={comment}
        eventName={['sale']}
      />,
      { isFeedBackNew: true }
    );
  };
  return (
    <div className={cn(styles.incomeCalculation, className)}>
      <div
        className={cn(
          styles.incomeCalculation__wrapper,
          withSocials && styles['incomeCalculation__wrapper--moreHight']
        )}
      >
        <H2 className={styles.incomeCalculation__title}>{t(title)}</H2>
        {withSocials ? (
          <div>
            <P3 className={styles.incomeCalculation__description}>
              {t(description)}
            </P3>
            <Messengers />
          </div>
        ) : (
          <Button
            as={'button'}
            label={t(buttonLabel)}
            theme={'light-invert'}
            size={'lg'}
            className={styles.incomeCalculation__button}
            onClick={openModal}
          />
        )}

        <Image
          className={styles.incomeCalculation__leaves}
          src={'/leaves/calculation_bg.webp'}
          loader={({ src }) => src}
          sizes="100vw"
          width={565}
          height={372}
          alt=""
        />
        <Image
          className={styles.incomeCalculation__leavesMobile}
          src={'/leaves/calculation_bg_mob.webp'}
          loader={({ src }) => src}
          width={343}
          height={580}
          alt=""
          sizes="100vw"
        />
        <Image
          className={cn(
            styles.incomeCalculation__expert,
            withSocials && styles['incomeCalculation__expert--moreRight']
          )}
          src={expert}
          loader={({ src }) => src}
          width={364}
          height={301}
          alt=""
          sizes="100vw"
          style={{ objectFit: 'cover' }}
        />
      </div>
    </div>
  );
};
